import Vue from 'vue'

class Register {
  async index() {
    return await Vue.axios
      .get('app/register')
  }
}

const register = new Register()

export default register
